import axios from 'axios';

const actions = {
  async getInfo({ commit }, token) {
    const resp = await axios.put(`${process.env.API_ROOT}/research-info/`, {
      token,
    });

    return resp.data;
  },

  async setAnswer({ commit }, obj) {
    let resp;
    const apiServerless = process.env.API_SERVERLESS;
    // serverless test
    if (obj.enableServerless && apiServerless) {
      resp = await axios.post(`${apiServerless}/answer`, { ...obj });
    } else {
      resp = await axios.post(`${process.env.API_ROOT}/answer`, {
        ...obj,
      });
    }
    return resp.data;
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/research/actions.js